import AuthSelector from './src/main';

/* istanbul ignore next */
AuthSelector.install = function(Vue) {
  Vue.component(AuthSelector.name, AuthSelector);
};

export default AuthSelector;
